import { renderToString } from 'react-dom/server';
const componentToString = htmlString => {
  const parser = new DOMParser();
  const doc = parser.parseFromString(renderToString(htmlString), 'text/html');
  const textContent = doc.body.textContent || '';
  return textContent.trim();
};

export default componentToString;
